import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
	// Add validation rules as needed
	// Example:
	// tinNumber: Yup.string().required('TIN Number is required'),
	// registeredPostalCode: Yup.string().required('Postal Code is required'),
});
